/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import type { TdSelectInputProps } from './type';

export const selectInputDefaultProps: TdSelectInputProps = {
  allowInput: false,
  autoWidth: false,
  autofocus: false,
  borderless: false,
  clearable: false,
  loading: false,
  minCollapsedNum: 0,
  multiple: false,
  readonly: false,
  readOnly: false,
  reserveKeyword: false,
  status: 'default',
};
